import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import i18n from '~/i18n'
import ImportContactsSplash from '~/Common-Objects/Onboarding/splashes/import-contacts.png'
import { OnboardingStep } from '~/Common-Objects/Onboarding'

export default function ImportStep({ isOpen, isComplete, onClick, onImport, postHogTag }) {
    return (
        <OnboardingStep
            key='import'
            title={i18n.t('setup:steps.import-contacts.title')}
            icon={<Icons icon='documentUpload' color='currentColor' />}
            isOpen={isOpen}
            isComplete={isComplete}
            onClick={onClick}
        >
            <p>{i18n.t('setup:steps.import-contacts.content')}</p>
            <div>
                <Button
                    className='button-primary button-small'
                    iconRight={<Icons icon='arrowRight' />}
                    onClick={(e) => {
                        e.stopPropagation()
                        onImport()
                    }}
                    postHogTag={postHogTag}
                >
                    {i18n.t('setup:steps.import-contacts.button-text')}
                </Button>
            </div>
        </OnboardingStep>
    )
}

ImportStep.splash = <img src={ImportContactsSplash} alt={i18n.t('setup:steps.import-contacts.title')} />
